import React, { useEffect, useState } from 'react';
import azureDevOpsService from './services/azureDevOpsService';
import { getSprintPeriods, getCurrentSprintIndex } from './utils/sprintUtils';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function KpiBugsBySprint() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      // Sprint 23: starts Wed 5 Nov 2025
      const sprintStart = new Date('2025-11-05T00:00:00');
      const sprintStartNumber = 23;
      const currentSprintIndex = getCurrentSprintIndex(sprintStart);
      const firstSprintIndex = Math.max(0, currentSprintIndex - 7);
      const sprints = getSprintPeriods(sprintStart, firstSprintIndex, 8, sprintStartNumber);
      const bugs = await azureDevOpsService.getBugsWithTA();
      // Group bugs by sprint
      const sprintData = sprints.map(sprint => {
        const count = bugs.filter(bug => {
          const created = new Date(bug.creationDate);
          return created >= sprint.start && created <= sprint.end;
        }).length;
        return { sprint: sprint.name, start: sprint.start, end: sprint.end, count };
      });
      setChartData({
        labels: sprintData.map(row => row.sprint),
        datasets: [
          {
            label: 'Nbr de bugs TA',
            data: sprintData.map(row => row.count),
            backgroundColor: 'rgba(59, 130, 246, 0.7)',
          },
        ],
      });
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="bg-white rounded shadow p-6">
      <h2 className="text-lg font-bold mb-4">Bugs TA par sprint</h2>
      {loading || !chartData ? (
        <div>Chargement...</div>
      ) : (
        <Bar
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: { display: false },
              title: {
                display: true,
                text: 'Nombre de bugs TA par sprint (8 derniers)',
              },
            },
            scales: {
              x: { title: { display: true, text: 'Sprint' } },
              y: { title: { display: true, text: 'Nbr de bugs' }, beginAtZero: true },
            },
          }}
        />
      )}
    </div>
  );
}
